import axios from 'axios';
import Swal from 'sweetalert2';
import siteConfig from '../config/site.config';
import * as actions from '../actions/ssg/index';
import { createBrowserHistory } from 'history';
import { getNewToken } from '../services/ssg/ssg';
import store from '../common/redux/store';

const history = createBrowserHistory();

// for multiple requests
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const axiosInstance = axios.create({
  baseURL: siteConfig.apiUrl
});

axiosInstance.interceptors.response.use(
  function(response) {
    return response;
  },
  error => {
    const originalReq = error.config;
    // console.log(error.response);
    if (error.response.status === 401 && !originalReq._retry) {
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalReq.headers['authorization'] = token;
            return axios(originalReq);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalReq._retry = true;
      isRefreshing = true;

      const refToken = localStorage.getItem('armoryRefreshToken');
      const refreshToken = {
        refresh_token: refToken
      };

      return new Promise((resolve, reject) => {
        getNewToken(refreshToken)
          .then(response => {
            const token = response.data.token;
            const refreshToken = response.data.refresh_token;
            const userId = localStorage.getItem('userId');
            const userType = 'armory';
            const avatar = null;

            localStorage.setItem('armoryToken', token);
            localStorage.setItem('armoryRefreshToken', refreshToken);
            localStorage.setItem('armoryUserId', userId);
            localStorage.setItem('armoryUserType', userType);

            // store.dispatch(actions.authSuccess(token, refreshToken, userId, userType, avatar));

            originalReq.headers['authorization'] = token;

            processQueue(null, token);

            resolve(axios(originalReq));
          })
          .catch(err => {
            if (err.response.status === 401 || err.response.status === 400) {
              history.go('/admin');
              // const res = Swal.fire({
              //   title: 'Session Expired!',
              //   text: 'Your session has expired. Please login again.',
              //   icon: 'warning',
              //   confirmButtonText: 'Log In',
              //   allowOutsideClick: false,
              //   allowEscapeKey: false,
              //   allowEnterKey: false
              // }).then(result => {
              //   if (result.isConfirmed) {
              //     // actions.logout();
              //     history.go('/admin');
              //   }
              // });
            }
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
